import React, {useEffect, useState} from "react";
import {Redirect} from "react-router";
import {useWauth} from "../auth/WauthProvider";

const CallbackPage = () => {

  const {handleAuthentication, isAuthenticated} = useWauth()
  const [message, setMessage] = useState("Verificando cuenta")

  const referer = '/selector'

  useEffect(() => {
    handleAuthentication()
  }, [])


  if (isAuthenticated) {
    return <Redirect to={referer}/>
  }

  return (
    <div>
      {message}
    </div>
  )
};

export default CallbackPage;
